<template>
    <input>
</template>

<script>
  export default {
    name: 'Range',
    props: ['min', 'max', 'from', 'to'],
    mounted: function () {
      let vm = this
      window.$(this.$el).ionRangeSlider(
        {
          type: 'double',
          min: vm.min,
          max: vm.max,
          from: this.from,
          to: this.to,
          grid: true,
          force_edges: true,
          onFinish: function (data) {
            vm.$emit('finish', data)
          }
        }
      )
      vm.slider = window.$(this.$el).data('ionRangeSlider')
    },
    data: function () {
      return {
        slider: null
      }
    },
    watch: {
      from: function (value) {
        this.slider.update({
          from: value
        })
      },
      to: function (value) {
        this.slider.update({
          to: value
        })
      },
      max: function (value) {
        this.slider.update({
          max: value
        })
      }
    },
    destroyed: function () {
      window.$(this.$el).off().ionRangeSlider('remove')
    }
  }
</script>



// WEBPACK FOOTER //
// src/vue/components/rangeSlider/Range.vue